import { gql, useQuery } from '@apollo/client';

export const GENERATE_REPORT = gql`
  query generateReport($input: GenerateReportInput!) {
    generateReport(input: $input) {
      grouping
      totalCount
    }
  }
`;

export const useQueryBuilder = (query: any) => {
  const { data, loading, refetch } = useQuery(GENERATE_REPORT, {
    variables: {
      input: {
        columns: [],
        pagination: {
          perPage: 0,
          page: 1,
        },
        sorting: {
          sortField: 'createdAt',
          sortDesc: true,
        },
        ...query,
      },
    },
    skip: !query,
  });

  return {
    data,
    loading,
    refetch,
  };
};
